module.exports = __webpack_public_path__ + "static/img/4sv.33d37f06.png";